module.exports = __webpack_public_path__ + "img/微信2.3e20ea1b.png";